app.controller("AgencyCityListController",
	["$scope", "$http", "$compile", "$timeout", "BrowserStorageService", function($scope, $http, $compile, $timeout, BrowserStorageService) {
		$scope.postcode = '';
		$scope.validPostcode = false;
		$scope.foundAgencies = true;
		$scope.agencies = [];
		$scope.map = undefined;
		$scope.markers = undefined;
		$scope.agenciesNarrowed = BrowserStorageService.LocalStorage.GetItem('frontPageAgencySearchInit') || false;
		$scope.selectedAgency = {
			responsibleFor: undefined,
			city: undefined,
			key: undefined
		};
		$scope.mapOptions = {
			zoom: 4,
			center: [65.548164, 23.823543],
			// scrollwheel: true,
			gestureHandling: "cooperative",
			styles: [
				{
					featureType: "poi",
					stylers: [
						{ visibility: "off" }
					]
				}
			]
		};

		var initialised = false;

		$scope.$watch('postcode',function() {
			if ($scope.postcode) {
				$scope.validPostcode = /^[0-9]{5}$/.test($scope.postcode);
			}
		});

		$scope.$watch('reRender', function(newVal, oldVal) {
			if (newVal && newVal !== oldVal && !initialised) {
				$timeout(function() {
					google.maps.event.trigger($scope.map.map, 'resize');
					var bounds = new google.maps.LatLngBounds();
					bounds.extend(new google.maps.LatLng(65.548164, 23.823543));
					$scope.map.map.fitBounds(bounds);
					$scope.map.map.setZoom(4);
				});
				initialised = true;
			}
		});

		loadAgencies();

		$scope.zoomInto = function(coords) {
			var city;
			if(typeof coords === 'string') {
				city = coords;
			}
			else {
				city = coords[2];
			}
			$scope.getAgencies(city);
			//panTo([coords[0], coords[1]]);

			return false;
		};

		$scope.getAgencies = function(area) {
			var bounds = new google.maps.LatLngBounds();
			var agenciesFound = 0;
			
			resetSelectedAgency();
			
			var agenciesNode = angular.element('.b-front__agency-content-agencies')[0];
			if(agenciesNode) {
				agenciesNode.scrollTop = 0;
				$scope.hideModal();
			}

			if (window.isFront) {
				if (/[0-9]{5}/.test(area)) {
					$scope.selectedAgency.responsibleFor = area;

					/* Only track postcode and area if there are results */
					var foundAgencies = [];
					for (var a = 0, l = $scope.agencies.length; a < l; a++) {
						if ($scope.agencies[a].responsibleFor.indexOf(area) !== -1) {
							foundAgencies.push($scope.agencies[a]);
						}
					}
					if (foundAgencies.length > 0 && window.wakeHistory) {
						window.wakeHistory.trackHistory('seller-county', foundAgencies[0].city);
						window.wakeHistory.trackHistory('seller-postcode', area);
					}	
				} else {
					$scope.selectedAgency.city = area;
				}

			} else {
				if (/[0-9]{5}/.test(area)) {
					$scope.selectedAgency.responsibleFor = area;
					// If wakeHistory is loaded, track history for postcode
					if (window.wakeHistory) {
						window.wakeHistory.trackHistory('seller-postcode', area);
					}
				}
				else {
					$scope.selectedAgency.city = area;
					// If wakeHistory is loaded, track history for county
					if (window.wakeHistory) {
						window.wakeHistory.trackHistory('seller-county', area);
					}
				}
			}

			$scope.agencies.sort(function(a, b) {
				if(a.city === area && b.city !== area) {
					return -1;
				}
				if(a.city !== area && b.city === area) {
					return 1;
				}
				return 0;
			});

			for (var i = 0, max = $scope.agencies.length; i < max; i++) {
				if (($scope.selectedAgency.city !== undefined && $scope.agencies[i].city === area) ||
					($scope.selectedAgency.responsibleFor !== undefined && $scope.agencies[i].responsibleFor.indexOf(area) !== -1) ||
				 	($scope.agencies[i].key !== undefined && $scope.agencies[i].key === area)) {
					bounds.extend(new google.maps.LatLng($scope.agencies[i].lat, $scope.agencies[i].lng));
					agenciesFound++;
					if (agenciesFound === 1) {
						// If wakeHistory is loaded, track history for postcode
						if (window.wakeHistory) {
							window.wakeHistory.trackHistory('seller-postcode', $scope.agencies[i].postcode);
						}
						// If wakeHistory is loaded, track history for county
						if (window.wakeHistory) {
							window.wakeHistory.trackHistory('seller-county', $scope.agencies[i].city);
						}
					}
				}
			}

			// KIIN-701: Turns out, fitBounds is asynchronous so the setZoom call will fail if we perform it right after.
			// using a callback fixes this
			if (agenciesFound === 1) {
				google.maps.event.addListenerOnce($scope.map.map, 'bounds_changed', function(event) {
					$scope.map.map.setZoom(14);
				});
			}
			$scope.map.map.fitBounds(bounds);

			$scope.foundAgencies = agenciesFound > 0;
		};

		$scope.hideModal = function() {
			if (!$scope.agenciesNarrowed) {
				$scope.agenciesNarrowed = true;

				BrowserStorageService.LocalStorage.SetItem('frontPageAgencySearchInit', true);
			}
		};

		window.onunload = function() {
			BrowserStorageService.LocalStorage.RemoveItem('frontPageAgencySearchInit', true);
		};

		$scope.initializeMap = function(map) {
			$scope.map = map;
		};

		function panTo(coords) {
			$scope.map.map.panTo({lat: coords[0], lng: coords[1]});
		}

		function getCoords(address) {
			return $http.get('https://maps.google.com/maps/api/geocode/json?address=' + address + ',Finland&sensor=false');
		}

		function showAgencyOnList(id) {
			var agenciesNode = angular.element('.b-agency-city-map__agencies');

			if(agenciesNode.length) {
				resetSelectedAgency();
				
				$timeout(function() {
					agenciesNode.scrollTop(0);
					$('.b-agency-city-map__agencies').animate({scrollTop: angular.element('#agency_' + id).position().top}, 500);
					angular.element('.b-agency-city-map__agency').removeClass('active');
					angular.element('#agency_' + id).addClass('active');
				});
			}
		}

		function resetSelectedAgency() {
			$scope.selectedAgency = {
				responsibleFor: undefined,
				city: undefined,
				key: undefined
			};

			angular.element('.b-front__agency-content-agencies.active').removeClass('active');
		}

		function loadAgencies() {
			var query = {random: true, limit: 1000};

			$http.get('/api/km/KMSite/agencySearch', {params: query}).then(
				function(response) {
					$scope.agencies = [];

					for (var i = 0, max = response.data.data.results.length; i < max; i++) {
						var agency = {
							lat: response.data.data.results[i].coordinates.latitude,
							lng: response.data.data.results[i].coordinates.longitude,
							address: response.data.data.results[i].address,
							city: response.data.data.results[i].city,
							companyName: response.data.data.results[i].marketingName,
							postcode: response.data.data.results[i].postcode,
							phone: response.data.data.results[i].phone,
							telPhone: response.data.data.results[i].telPhone,
							email: response.data.data.results[i].email,
							url: response.data.data.results[i].urlParts[0],
							key: response.data.data.results[i].key,
							responsibleFor: response.data.data.results[i].responsibleFor,
							zIndex: i + 1
						};
						$scope.agencies.push(agency);
						addMarker(agency);	 
					}
					
					if($scope.zoomToCity) {
						$scope.zoomInto($scope.zoomToCity);
					}
				}, 
				function(error) {
				}
			);
		}

		function addMarker(agency) {
			var marker = null;

			if ($scope.map && $scope.map.controls) {
				marker = $scope.map.controls.AddMarker([agency.lat, agency.lng], 'assets/images/pin-regular.png', agency.zIndex, true);
			}

			if (marker) {
				if ($scope.infoboxTemplate) {
					$scope.map.controls.AddInfoBox(marker, $scope.infoboxTemplate, null, $scope);
					marker.infoBoxScope.agency = agency;
				}

				google.maps.event.addListener(marker, 'click', function () {
					if (typeof $scope.onItemClick === 'function') {
						$scope.onItemClick({agency: agency});
					}
					else {
						showAgencyOnList(agency.key);
					}
				});

				$scope.markers = $scope.map.controls.GetMarkers();
			}
		}
	}]
);